import React from 'react';

function Ethiopia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124139)">
        <mask
          id="mask0_800_124139"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124139)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#FECA00"
          />
          <mask
            id="mask1_800_124139"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124139)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#5EAA22"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#E31D1C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 18C21.7279 18 24.75 15.3137 24.75 12C24.75 8.68629 21.7279 6 18 6C14.2721 6 11.25 8.68629 11.25 12C11.25 15.3137 14.2721 18 18 18Z"
              fill="#2B77B8"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 14L14.8927 14.9265L15.8601 12.618L13.7524 10.382H16.6774L18 8L19.3225 10.382H22.312L20.1398 12.618L20.9108 14.9265L18 14Z"
              stroke="#FECA00"
              strokeWidth="1.5"
            />
            <path d="M17.6582 12.0345L15.313 16.3946" stroke="#2B77B8" />
            <path d="M17.2891 11.4795H12.7891" stroke="#2B77B8" />
            <path d="M18.1367 12.8376L22.5344 14.6417" stroke="#2B77B8" />
            <path d="M19.0874 11.8737L22.2707 8.77649" stroke="#2B77B8" />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124139">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Ethiopia;
